import AboutSection from '../components/HomeComps/AboutSection';
import CareersSection from '../components/HomeComps/CareersSection';
import ContactUsSection from '../components/HomeComps/ContactUsSection';
import HeroSection from '../components/HomeComps/HeroSection';
import HowItWorks from '../components/HomeComps/HowItWorks';
import PackagesSection from '../components/HomeComps/PackagesSection';
import PlatformAvailabilitySection from '../components/HomeComps/PlatformAvailabilitySection';
import PracticeArea from '../components/HomeComps/PracticeArea';

const Home = () => {
  // rendering home page component here
  return (
    <>
      <HeroSection />
      <HowItWorks />
      <AboutSection />
      <PlatformAvailabilitySection />
      <PracticeArea />
      <PackagesSection />
      <CareersSection />
      <ContactUsSection />
    </>
  );
};

export default Home;
